module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-spin-center"
  }, [_c('div', {
    staticClass: "m-wait"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "center-text"
  }, [_vm._v("正在查询")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46b4fa5e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/loading.vue
// module id = 83
// module chunks = 2 3 4 6 19